
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import { C as CollapseTransition } from './collapse-transition-mixin.js';

var script = {
  name: 'PendoCardSection',
  components: {
    PendoButton,
    CollapseTransition
  },
  props: {
    closable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isVisible: false
    };
  },

  mounted() {
    this.isVisible = true;

    if (this.$el.parentNode && this.$el.parentNode.classList[0] === 'pendo-card__body') {
      this.$el.parentNode.style.padding = 0;
    }
  },

  methods: {
    removeSelf() {
      this.isVisible = false;
      setTimeout(() => {
        this.$emit('close');

        if (this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el);
        }

        this.$destroy();
      }, 250);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('collapse-transition', {
    attrs: {
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isVisible,
      expression: "isVisible"
    }],
    staticClass: "pendo-card-section",
    class: {
      'pendo-card-section--closable': _vm.closable
    }
  }, [_c('div', {
    staticClass: "pendo-card-section__content"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.isVisible && _vm.closable ? _c('pendo-button', {
    staticClass: "pendo-card-section__close-button",
    attrs: {
      "theme": "app",
      "type": "tertiary",
      "icon": "x",
      "icon-size": "18"
    },
    on: {
      "click": _vm.removeSelf
    }
  }) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-card-section.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoCardSection = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoCardSection;
